<hs-multi-breaks-grid
  [dataVal]="data"
  [totalFocusedBreaks]="totalFocusedBreaks$ | async"
  [isDownloadSubmitted]="isDownloadSubmitted"
  [isLoading]="isLoading"
  [isJobCompleted]="isJobCompleted"
  [hasActiveSession]="hasActiveSession$ | async"
  [breaksLimitExceeded]="matchingBreaksCount === '10000+'"
  [invalidPermissions]="showInvalidPermissionsToGetBreaks"
  [isInCurrentSession]="isInCurrentSession"
  [popOverConfig]="popOverConfig"
  [currentSessionAccountIds]="_currentSessionAccountIds"
  [hasSameUltimateParent]="hasSameUltimateParent"
  [hasAccountId]="hasAccountId"
  [updatedBreaks$]="updatedBreaks$"
  [ultClientData]="ultClientData"
  [userFeatureAccess]="userFeatureAccess | async"
  (showDetails)="onShowDetails($event)"
  (editNote)="onEditNote($event)"
  (bulkEdit)="onBulkEdit($event)"
  (accept)="onAccept($event)"
  (unaccept)="onUnaccept($event)"
  (hold)="onHold($event)"
  (createIssue)="onCreateIssue($event)"
  (currentSessionSearchClicked)="onSearchCurrentSession()"
  (refreshAfterJobCompleted)="onRefreshAfterJobCompleted()"
  (onLoadAccount)="setLoadedAccountFromBreak($event)"
  (resolveCashBreak)="resolveCashBreak($event)"
  (openCashBreakSettings)="openCashBreakSettings($event)"
  (generateEmail)="generateEmail($event)"
  (initialSearchFilters)="initialSearchFilters($event)"
  (resetPopOverFilter)="resetPopOverFilter()"
  (exportToExcel)="exportToExcel($event)"
>
  <hs-find-multi-breaks-popover
    (find)="onDownloadSubmit($event)"
    (popoverFilterChanged)="popoverFilterChanged($event)"
    [accountsFilter]="popoverAccounts"
    #multiBreakPopover
  ></hs-find-multi-breaks-popover>
  <div class="flex-column breaks-form">
    <div class="mt-2" id="downloadedBreaksCount">
      Matching Breaks Count: {{ matchingBreaksCount }}
    </div>
  </div>
</hs-multi-breaks-grid>
